/* Velcroy conversion layer: bundle default, sticky add to cart, one-tap add-ons, back/forward restore.
   (The gift wrap option wires itself up in snippets/velcroy-gift-note.liquid.) */
(function () {
  /* ---------- Bundle widget: start on "Single" ----------
     The Super Subscriptions & Bundles block preselects "Double", which silently adds 2 bottles.
     The app applies its default after it initialises, so keep nudging the first tier (Single)
     for a few seconds after load — but never once the shopper has picked a tier themselves.
     Selecting it must not move focus or the page: a label click focuses the radio, and browsers
     scroll focused elements into view (that made product pages open half-way down). */
  var shopperPickedTier = false;

  document.addEventListener('click', function (e) {
    if (e.isTrusted && e.target.closest && e.target.closest('.sss-bundle-block__tier-row, .sss-bundle-block__radio')) {
      shopperPickedTier = true;
    }
  }, true);

  function selectSingleTier() {
    if (shopperPickedTier) return;
    var single = document.querySelector('.product__info-container .sss-bundle-block__radio[value="0"]');
    if (!single || single.checked) return;
    var x = window.scrollX;
    var y = window.scrollY;
    var previous = document.activeElement;
    (single.closest('label') || single).click();
    if (document.activeElement === single) {
      single.blur();
      if (previous && previous !== document.body && typeof previous.focus === 'function') {
        previous.focus({ preventScroll: true });
      }
    }
    if (window.scrollX !== x || window.scrollY !== y) window.scrollTo(x, y);
  }

  function enforceSingleFor(ms) {
    var until = Date.now() + ms;
    var timer = setInterval(function () {
      selectSingleTier();
      if (shopperPickedTier || Date.now() > until) clearInterval(timer);
    }, 250);
  }

  function watchBundle() {
    if (!document.querySelector('.product__info-container [data-sss-instance], .product__info-container .sss-stack')) return;
    enforceSingleFor(6000);
    window.addEventListener('load', function () { enforceSingleFor(3000); });
    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('.product__info-container variant-selects')) enforceSingleFor(2000);
    });
  }

  /* ---------- Sticky add to cart ----------
     Visible only when: the main button has scrolled above the viewport, the footer isn't on screen,
     no drawer/modal/menu is open, and the shopper isn't typing (mobile keyboards move fixed bars).
     Checked once per animation frame on scroll, so it never flickers.
     While visible, <html> gets .vlc-sticky-on so floating widgets (chat, newsletter teaser) make room. */
  var refreshSticky = function () {};

  function initSticky() {
    var bar = document.querySelector('[data-vlc-sticky]');
    var mainBtn = document.querySelector('.product__info-container button[name="add"]');
    if (!bar || !mainBtn) return;

    var stickyBtn = bar.querySelector('[data-vlc-sticky-btn]');
    var stickyPrice = bar.querySelector('[data-vlc-sticky-price]');
    var mainPrice = document.querySelector('.product__info-container .price');
    var footer = document.querySelector('.footer') || document.querySelector('footer');
    var drawer = document.querySelector('cart-drawer');
    var shown = false;
    var ticking = false;
    var typing = false;

    function overlayOpen() {
      if (drawer && drawer.classList.contains('active')) return true;
      if (document.body.className.indexOf('overflow-hidden') !== -1) return true; // Dawn: drawer, menu drawer, modals
      return !!document.querySelector('quick-add-modal[open], product-modal[open], details[open] > .menu-drawer');
    }

    function shouldShow() {
      if (typing || overlayOpen()) return false;
      if (mainBtn.getBoundingClientRect().bottom > 0) return false;
      if (footer && footer.getBoundingClientRect().top < window.innerHeight) return false;
      return true;
    }

    function update() {
      ticking = false;
      var next = shouldShow();
      if (next === shown) return;
      shown = next;
      bar.classList.toggle('is-visible', next);
      bar.setAttribute('aria-hidden', next ? 'false' : 'true');
      stickyBtn.tabIndex = next ? 0 : -1;
      document.documentElement.classList.toggle('vlc-sticky-on', next);
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }
    refreshSticky = requestUpdate;

    function syncState() {
      stickyBtn.disabled = mainBtn.disabled;
      var label = mainBtn.querySelector('span');
      stickyBtn.textContent = (label ? label.textContent : mainBtn.textContent).trim() || 'Add to cart';
      if (mainPrice && stickyPrice) {
        var current = mainPrice.querySelector('.price__sale:not([hidden]) .price-item--last, .price-item--last') || mainPrice.querySelector('.price-item');
        if (current && current.textContent.trim()) stickyPrice.textContent = current.textContent.trim();
      }
    }

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    document.addEventListener('focusin', function (e) {
      if (e.target.matches && e.target.matches('textarea, select, input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"])')) {
        typing = true;
        requestUpdate();
      }
    });
    document.addEventListener('focusout', function () {
      typing = false;
      setTimeout(requestUpdate, 200);
    });
    if (drawer) new MutationObserver(requestUpdate).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    new MutationObserver(requestUpdate).observe(document.body, { attributes: true, attributeFilter: ['class'] });

    stickyBtn.addEventListener('click', function () {
      if (!mainBtn.disabled) mainBtn.click();
    });

    syncState();
    new MutationObserver(syncState).observe(mainBtn, { attributes: true, childList: true, subtree: true });
    if (mainPrice) new MutationObserver(syncState).observe(mainPrice, { childList: true, subtree: true, characterData: true });
    update();
  }

  /* ---------- One-tap add-ons (cart drawer, cart page, product page) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-vlc-upsell]');
    if (!btn) return;
    e.preventDefault();
    btn.disabled = true;

    var onCartPage = window.location.pathname === (window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart');
    var drawer = onCartPage ? null : document.querySelector('cart-drawer');
    var body = { items: [{ id: Number(btn.dataset.vlcUpsell), quantity: 1 }] };
    if (drawer) {
      body.sections = 'cart-drawer,cart-icon-bubble';
      body.sections_url = window.location.pathname;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (res) { return res.json(); })
      .then(function (json) {
        if (json.status) throw new Error(json.description || json.message);
        if (drawer && json.sections && typeof drawer.renderContents === 'function') {
          drawer.renderContents({ sections: json.sections, id: json.items && json.items[0] && json.items[0].id });
          if (!btn.closest('cart-drawer')) {
            btn.disabled = false;
            btn.textContent = 'Added';
          }
        } else {
          window.location.reload();
        }
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.textContent = 'Unavailable';
        console.error('Velcroy add-on:', err);
      });
  });

  /* ---------- Back / forward restore ----------
     Mobile Safari and Chrome often restore the previous page frozen exactly as it was left
     (the back-forward cache). Close anything left open, unlock scrolling and refresh the cart,
     which may have changed on the page the shopper just came from. Scroll position is left to the browser. */
  function refreshCartUI() {
    if (window.location.pathname === '/cart') {
      window.location.reload();
      return;
    }
    fetch('/?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var parse = function (html) { return new DOMParser().parseFromString(html, 'text/html'); };
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && sections['cart-icon-bubble']) {
          var freshBubble = parse(sections['cart-icon-bubble']).querySelector('.shopify-section');
          if (freshBubble) bubble.innerHTML = freshBubble.innerHTML;
        }
        var drawerEl = document.querySelector('cart-drawer');
        if (drawerEl && sections['cart-drawer']) {
          var freshDoc = parse(sections['cart-drawer']);
          var fresh = freshDoc.querySelector('#CartDrawer');
          var current = document.getElementById('CartDrawer');
          if (fresh && current) current.innerHTML = fresh.innerHTML;
          var freshDrawer = freshDoc.querySelector('cart-drawer');
          if (freshDrawer) drawerEl.classList.toggle('is-empty', freshDrawer.classList.contains('is-empty'));
        }
      })
      .catch(function () {});
  }

  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    document.querySelectorAll('quick-add-modal[open], product-modal[open]').forEach(function (m) {
      if (typeof m.hide === 'function') m.hide(true);
      else m.removeAttribute('open');
    });
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && cartDrawer.classList.contains('active') && typeof cartDrawer.close === 'function') cartDrawer.close();
    var menu = document.querySelector('#Details-menu-drawer-container[open]');
    if (menu) {
      menu.removeAttribute('open');
      menu.classList.remove('menu-opening');
    }
    document.querySelectorAll('header-menu details[open]').forEach(function (d) { d.removeAttribute('open'); });
    document.body.classList.remove('overflow-hidden', 'overflow-hidden-mobile', 'overflow-hidden-tablet', 'overflow-hidden-desktop');
    refreshCartUI();
    refreshSticky();
  });

  function init() {
    watchBundle();
    initSticky();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();